import List from './List';
import Create from './Create';
import Edit from './Edit';

export const Project = {
  List,
  Create,
  Edit,
};
